// extracted by mini-css-extract-plugin
export var disclaimer = "DisclaimerText-module--disclaimer--5c03d";